import React from "react";
import { Link } from "react-router-dom";

import { FaFacebookF } from "react-icons/fa";
import { AiOutlineTwitter } from "react-icons/ai";
import { AiOutlineInstagram } from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";
import ScrollToTop from "react-scroll-to-top";

const Footer = () => {
  return (
    <div className="">
      <ScrollToTop className="-mr-5 -mb-6 z-40 text-bold"
      
        smooth
        viewBox="20 -100 50 500"
        style={{
          backgroundColor: "#f04f25",
          textAlign: "center",
          textLeft: "2px",
          font:"bold"
          
        }}
        top="120"
        color="white"
      />
      {/* max-w-[1536px] */}
      <div className="bg-[#193f6c] text-left ml-auto mr-auto text-white ">
      
      </div>
      <hr className="" />

      {/* <div className="w-full bg-[#4e5f64] text-gray-500 px-10  ml-auto mr-auto">
        <div className="max-w-7xl flex flex-col sm:flex-row py-4 mx-auto justify-between items-center">
          <div className="text-center text-white">
            <div>
              Copyright{" "}
              <strong>
                <span>Iccheporin</span>
              </strong>{" "}
              All Rights Reserved
            </div>
            <div>
              Designed by{" "}
              <Link className="text-yellow-500" to="/home">
                Jony
              </Link>
            </div>
          </div>

          <div className="text-center text-xl text-white mb-2">
            <Link
              to=""
              className="w-10 h-10 rounded-full bg-[#4d6391] hover:bg-white hover:text-black mx-1 inline-block pt-1"
            >
              <FaFacebookF className="ml-auto mr-auto  mt-1.5"></FaFacebookF>{" "}
            </Link>
            <Link
              to=""
              className="w-10 h-10 rounded-full bg-[#4d6391] hover:bg-white hover:text-black mx-1 inline-block pt-1"
            >
              <AiOutlineTwitter className="ml-auto mr-auto  mt-1.5"></AiOutlineTwitter>{" "}
            </Link>
            <Link
              to=""
              className="w-10 h-10 rounded-full bg-[#4d6391] hover:bg-white hover:text-black mx-1 inline-block pt-1"
            >
              <AiOutlineInstagram className="ml-auto mr-auto  mt-1.5"></AiOutlineInstagram>{" "}
            </Link>
            <Link
              to=""
              className="w-10 h-10 rounded-full  bg-[#4d6391] hover:bg-white hover:text-black mx-1 inline-block pt-1"
            >
              <FaLinkedinIn className="ml-auto mr-auto  mt-1.5"></FaLinkedinIn>{" "}
            </Link>
          </div>
        </div>
      </div> */}





{/* <!-- component --> 193f6c */}
<div className="mb-16">
  <footer className="text-gray-600 body-font bg-[#0f0f00]">
    <div className="container px-5 py-24 mx-auto flex md:items-center lg:items-start md:flex-row md:flex-nowrap flex-wrap flex-col">
      <div className="w-40 ml-auto mr-auto flex-shrink-0 md:mx-0 mx-auto text-center md:text-left">
        <Link className="flex title-font font-medium items-center md:justify-start justify-center text-gray-900">
       

         <img className="" src="https://i.ibb.co/f8Q76Qh/primeautomation111111-removebg-preview.png" alt="primeautomation111111-removebg-preview" border="0"></img>
         
        </Link>
        <p className="mt-2 text-sm text-white">Air plant banjo lyft occupy retro adaptogen indegoAir plant banjo lyft occupy retro adaptogen indego</p>
      </div>
      <div className="flex-grow flex flex-wrap md:pl-20 -mb-10 md:mt-0 mt-10 md:text-left text-center">
        <div className="lg:w-1/4 md:w-1/2 w-full px-4">
          <h2 className="title-font font-bold text-white tracking-widest text-md mb-3">CATEGORIES</h2>
          <nav className="list-none mb-10">
            <li>
              <Link className="text-white hover:text-red-300" href="#">First Link</Link>
            </li>
            <li>
              <Link className="text-white hover:text-red-300" href="#">Second Link</Link>
            </li>
            <li>
              <Link className="text-white hover:text-red-300" href="#">Third Link</Link>
            </li>
            <li>
              <a className="text-white hover:text-red-300" href="#">Fourth Link</a>
            </li>
          </nav>
        </div>
        <div className="lg:w-1/4 md:w-1/2 w-full px-4">
          <h2 className="title-font font-bold text-white tracking-widest text-md mb-3">CATEGORIES</h2>
          <nav className="list-none mb-10">
            <li>
              <a className="text-white hover:text-red-300" href="#">First Link</a>
            </li>
            <li>
              <a className="text-white hover:text-red-300" href="#">Second Link</a>
            </li>
            <li>
              <a className="text-white hover:text-red-300" href="#">Third Link</a>
            </li>
            <li>
              <a className="text-white hover:text-red-300" href="#">Fourth Link</a>
            </li>
          </nav>
        </div>
        <div className="lg:w-1/4 md:w-1/2 w-full px-4">
          <h2 className="title-font font-bold text-white tracking-widest text-md mb-3">CATEGORIES</h2>
          <nav className="list-none mb-10">
            <li>
              <a className="text-white hover:text-red-300" href="#">First Link</a>
            </li>
            <li>
              <a className="text-white hover:text-red-300" href="#">Second Link</a>
            </li>
            <li>
              <a className="text-white hover:text-red-300" href="#">Third Link</a>
            </li>
            <li>
              <a className="text-white hover:text-red-300" href="#">Fourth Link</a>
            </li>
          </nav>
        </div>
        <div className="lg:w-1/4 md:w-1/2 w-full px-4">
          <h2 className="title-font font-bold text-white tracking-widest text-md mb-3">CATEGORIES</h2>
          <nav className="list-none mb-10">
            <li>
              <a className="text-white hover:text-red-300" href="#">First Link</a>
            </li>
            <li>
              <a className="text-white hover:text-red-300" href="#">Second Link</a>
            </li>
            <li>
              <a className="text-white hover:text-red-300" href="#">Third Link</a>
            </li>
            <li>
              <a className="text-white hover:text-red-300" href="#">Fourth Link</a>
            </li>
          </nav>
        </div>
      </div>
    </div>
    <div className="bg-gray-900">
      <div className="container mx-auto py-4 px-5 flex flex-wrap flex-col sm:flex-row">
        <p className="text-white text-sm text-center sm:text-left">© 2020 Dev —
          <a href="https://twitter.com/knyttneve" rel="noopener noreferrer" className="text-gray-400 ml-1" target="_blank">@PrimeAutomation</a>
        </p>
        <span className="inline-flex sm:ml-auto sm:mt-0 mt-2 justify-center sm:justify-start">
          <a className="text-gray-200">
            <svg fill="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" className="w-5 h-5" viewBox="0 0 24 24">
              <path d="M18 2h-3a5 5 0 00-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 011-1h3z"></path>
            </svg>
          </a>
          <a className="ml-3 text-gray-200">
            <svg fill="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" className="w-5 h-5" viewBox="0 0 24 24">
              <path d="M23 3a10.9 10.9 0 01-3.14 1.53 4.48 4.48 0 00-7.86 3v1A10.66 10.66 0 013 4s-4 9 5 13a11.64 11.64 0 01-7 2c9 5 20 0 20-11.5a4.5 4.5 0 00-.08-.83A7.72 7.72 0 0023 3z"></path>
            </svg>
          </a>
          <a className="ml-3 text-gray-200">
            <svg fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" className="w-5 h-5" viewBox="0 0 24 24">
              <rect width="20" height="20" x="2" y="2" rx="5" ry="5"></rect>
              <path d="M16 11.37A4 4 0 1112.63 8 4 4 0 0116 11.37zm1.5-4.87h.01"></path>
            </svg>
          </a>
          <a className="ml-3 text-gray-200">
            <svg fill="currentColor" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="0" className="w-5 h-5" viewBox="0 0 24 24">
              <path stroke="none" d="M16 8a6 6 0 016 6v7h-4v-7a2 2 0 00-2-2 2 2 0 00-2 2v7h-4v-7a6 6 0 016-6zM2 9h4v12H2z"></path>
              <circle cx="4" cy="4" r="2" stroke="none"></circle>
            </svg>
          </a>
        </span>
      </div>
    </div>
  </footer>
</div>

{/* <div className="">
  <footer className="text-gray-600 body-font bg-indigo-700">
    <div className="container px-5 py-24 mx-auto flex md:items-center lg:items-start md:flex-row md:flex-nowrap flex-wrap flex-col">
      <div className="w-64 flex-shrink-0 md:mx-0 mx-auto text-center md:text-left">
        <a className="flex title-font font-medium items-center md:justify-start justify-center text-gray-900">
          <svg xmlns="http://www.w3.org/2000/svg" className="w-10 h-10 text-white p-2 bg-pink-600 rounded-full" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 18h.01M7 21h10a2 2 0 002-2V5a2 2 0 00-2-2H7a2 2 0 00-2 2v14a2 2 0 002 2z" />
          </svg>
          <span className="ml-3 text-xl text-white">DEV</span>
        </a>
        <p className="mt-2 text-sm text-white">Air plant banjo lyft occupy retro adaptogen indego</p>
      </div>
      <div className="flex-grow flex flex-wrap md:pl-20 -mb-10 md:mt-0 mt-10 md:text-left text-center">
        <div className="lg:w-1/4 md:w-1/2 w-full px-4">
          <h2 className="title-font font-bold text-white tracking-widest text-md mb-3">CATEGORIES</h2>
          <nav className="list-none mb-10">
            <li>
              <a className="text-white hover:text-red-300" href="#">First Link</a>
            </li>
            <li>
              <a className="text-white hover:text-red-300" href="#">Second Link</a>
            </li>
            <li>
              <a className="text-white hover:text-red-300" href="#">Third Link</a>
            </li>
            <li>
              <a className="text-white hover:text-red-300" href="#">Fourth Link</a>
            </li>
          </nav>
        </div>
        <div className="lg:w-1/4 md:w-1/2 w-full px-4">
          <h2 className="title-font font-bold text-white tracking-widest text-md mb-3">CATEGORIES</h2>
          <nav className="list-none mb-10">
            <li>
              <a className="text-white hover:text-red-300" href="#">First Link</a>
            </li>
            <li>
              <a className="text-white hover:text-red-300" href="#">Second Link</a>
            </li>
            <li>
              <a className="text-white hover:text-red-300" href="#">Third Link</a>
            </li>
            <li>
              <a className="text-white hover:text-red-300" href="#">Fourth Link</a>
            </li>
          </nav>
        </div>
        <div className="lg:w-1/4 md:w-1/2 w-full px-4">
          <h2 className="title-font font-bold text-white tracking-widest text-md mb-3">CATEGORIES</h2>
          <nav className="list-none mb-10">
            <li>
              <a className="text-white hover:text-red-300" href="#">First Link</a>
            </li>
            <li>
              <a className="text-white hover:text-red-300" href="#">Second Link</a>
            </li>
            <li>
              <a className="text-white hover:text-red-300" href="#">Third Link</a>
            </li>
            <li>
              <a className="text-white hover:text-red-300" href="#">Fourth Link</a>
            </li>
          </nav>
        </div>
        <div className="lg:w-1/4 md:w-1/2 w-full px-4">
          <h2 className="title-font font-bold text-white tracking-widest text-md mb-3">CATEGORIES</h2>
          <nav className="list-none mb-10">
            <li>
              <a className="text-white hover:text-red-300" href="#">First Link</a>
            </li>
            <li>
              <a className="text-white hover:text-red-300" href="#">Second Link</a>
            </li>
            <li>
              <a className="text-white hover:text-red-300" href="#">Third Link</a>
            </li>
            <li>
              <a className="text-white hover:text-red-300" href="#">Fourth Link</a>
            </li>
          </nav>
        </div>
      </div>
    </div>
    <div className="bg-indigo-900">
      <div className="container mx-auto py-4 px-5 flex flex-wrap flex-col sm:flex-row">
        <p className="text-white text-sm text-center sm:text-left">© 2020 Dev —
          <a href="https://twitter.com/knyttneve" rel="noopener noreferrer" className="text-gray-400 ml-1" target="_blank">@Developer</a>
        </p>
        <span className="inline-flex sm:ml-auto sm:mt-0 mt-2 justify-center sm:justify-start">
          <a className="text-gray-200">
            <svg fill="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" className="w-5 h-5" viewBox="0 0 24 24">
              <path d="M18 2h-3a5 5 0 00-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 011-1h3z"></path>
            </svg>
          </a>
          <a className="ml-3 text-gray-200">
            <svg fill="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" className="w-5 h-5" viewBox="0 0 24 24">
              <path d="M23 3a10.9 10.9 0 01-3.14 1.53 4.48 4.48 0 00-7.86 3v1A10.66 10.66 0 013 4s-4 9 5 13a11.64 11.64 0 01-7 2c9 5 20 0 20-11.5a4.5 4.5 0 00-.08-.83A7.72 7.72 0 0023 3z"></path>
            </svg>
          </a>
          <a className="ml-3 text-gray-200">
            <svg fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" className="w-5 h-5" viewBox="0 0 24 24">
              <rect width="20" height="20" x="2" y="2" rx="5" ry="5"></rect>
              <path d="M16 11.37A4 4 0 1112.63 8 4 4 0 0116 11.37zm1.5-4.87h.01"></path>
            </svg>
          </a>
          <a className="ml-3 text-gray-200">
            <svg fill="currentColor" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="0" className="w-5 h-5" viewBox="0 0 24 24">
              <path stroke="none" d="M16 8a6 6 0 016 6v7h-4v-7a2 2 0 00-2-2 2 2 0 00-2 2v7h-4v-7a6 6 0 016-6zM2 9h4v12H2z"></path>
              <circle cx="4" cy="4" r="2" stroke="none"></circle>
            </svg>
          </a>
        </span>
      </div>
    </div>
  </footer>
</div> */}
    </div>
  );
};

export default Footer;
